import type { ChangePerformanceKitView } from "@slfinrtl/ui-bff-routes"
import { useEffect } from "react"
import type { UseFormReturn } from "react-hook-form"
import { useForm } from "react-hook-form"
import type { ChangeSelectedWheelsForm } from "src/hooks"

export const useChangePerformanceKitForm: (props: {
	view: ChangePerformanceKitView
}) => UseFormReturn<ChangeSelectedWheelsForm> = ({ view }) => {
	const form = useForm<ChangeSelectedWheelsForm>({
		defaultValues: {
			optionCode: "",
		},
	})

	useEffect(() => {
		form.reset(
			{
				optionCode: view?.option.optionCode ?? "",
			},
			{ keepFieldsRef: true },
		)
	}, [view?.option.optionCode, form])

	return form
}
